import type { SourceDefinition } from '../types';

export const config = {
  id: 'portfolio',
  kind: 'db',
} satisfies SourceDefinition;
